import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['SocialManager']['countFollowers']
type inputType = RouterInputs['SocialManager']['countFollowers']

export const useCountFollowers = (input: inputType, options?: optionsType) =>
    api.SocialManager.countFollowers.useQuery(input, {
        ...options,
        queryKey: ['SocialManager.countFollowers', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        refetchOnMount: true
    })
